import React from "react";
import { Stack } from "@mui/material";
import Row from "../Row";
import { XsText, XsTextMd } from "../Text";
import { COLORS } from "constants/layout";
import UserAvatar from "../avatar/UserAvatar";
import SendInquiryButton from "../button/SendInquiryButton";
import VisitCompanyButton from "../button/VisitCompanyButton";
import ViewProductButton from "../button/ViewProductButton";
import dayjs from "dayjs";
import { StyledRouterA } from "../Text";

interface OwnerInformationProps {
  data: {
    user_image?: string | null;
    farmer_name: string;
    salutation?: string;
    position?: string;
    identity?: string;
    farm_id: string;
    farm_path: string;
    farm_item_id?: string | null;
    farm_item_path?: string | null;
    last_active?: string | null;
  };
  isNotShowButton?: boolean;
  isFreePlan?: boolean;
  isFromSupplier?: boolean;
}

const OwnerInformation: React.FC<OwnerInformationProps> = ({
  data: {
    user_image,
    farmer_name,
    salutation = "",
    position = "",
    identity = "",
    farm_id,
    farm_path,
    farm_item_id,
    farm_item_path,
    last_active,
  },
  isNotShowButton,
  isFreePlan = false,
  isFromSupplier = false,
}) => {
  // Convert null values to undefined to satisfy the component props
  const stringOrUndefined = (
    value: string | null | undefined
  ): string | undefined => (value === null ? undefined : value);

  const itemId = stringOrUndefined(farm_item_id);
  // Show last activity hours, days, months, years ago
  const lastActivityTime = last_active ? dayjs(last_active).fromNow() : "";

  return (
    <Row spacing={{ xs: 1, md: 2 }} className="owner-info" mt={1}>
      <StyledRouterA
        to={farm_path}
        style={{
          textDecoration: "none",
          color: "inherit",
          flex: 1,
          minWidth: 0, // Prevent flex item from overflowing
        }}
      >
        <Row
          spacing={1}
          flex={1}
          overflow="hidden"
          className="left-box"
          sx={{
            display: {
              xs: "none",
              lg: "flex",
            },
          }}
        >
          <UserAvatar
            data={{
              user_image: user_image || undefined,
              salutation,
            }}
          />
          <Stack spacing={0.5} maxWidth="calc(100% - 48px)" minWidth={0}>
            <Row spacing={0.5} alignItems="center" minWidth={0}>
              <XsTextMd
                color={COLORS.gray[800]}
                className="ellipsis-text"
                sx={{ minWidth: 0 }}
              >
                {salutation ? `${salutation}. ` : ""}
                {farmer_name}
              </XsTextMd>
              {position && (
                <XsText
                  color={COLORS.gray[600]}
                  className="ellipsis-text"
                  sx={{ minWidth: 0 }}
                >
                  ({position})
                </XsText>
              )}
            </Row>

            {last_active && (
              <XsText
                color={COLORS.gray[500]}
                className="ellipsis-text"
                sx={{ minWidth: 0 }}
              >
                {lastActivityTime}
              </XsText>
            )}
          </Stack>
        </Row>
      </StyledRouterA>

      {!isNotShowButton && !isFreePlan && (
        <Row
          spacing={1.5}
          sx={{
            flexShrink: 0,
            minWidth: 0,
            flexWrap: "nowrap",
            justifyContent: "flex-end",
          }}
        >
          {itemId && (
            <ViewProductButton
              data={{ farm_item: itemId }}
              className="view-product-btn"
            />
          )}
          <SendInquiryButton
            data={{ farm_id, slug: farm_path, farm_item_id: itemId }}
            isFromSupplier={isFromSupplier}
          />
          {/* <VisitCompanyButton path={farm_path} /> */}
        </Row>
      )}
    </Row>
  );
};

export default OwnerInformation;
